import { render, staticRenderFns } from "./edge-tree.vue?vue&type=template&id=490f36c0&scoped=true&"
import script from "./edge-tree.vue?vue&type=script&lang=ts&"
export * from "./edge-tree.vue?vue&type=script&lang=ts&"
import style0 from "./edge-tree.vue?vue&type=style&index=0&id=490f36c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f36c0",
  null
  
)

export default component.exports